export const DsBottomNavigationDefaultProps = {
    showLabels: true
};
